export default "__VITE_PUBLIC_ASSET__89a6d69e__"